module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tjhzs_container"
    }
  }, [_c('nav-bar', {
    on: {
      "position": _vm.getPosition
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    style: (_vm.setMargin)
  })], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fab8711a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 193
// module chunks = 1